import React from 'react';
import CreditExceptionTag from 'features/brazil-grower/components/shared/CreditExceptionsAndConditionals/CreditExceptions/CreditExceptionTag';
import styled from 'styled-components';

interface SelectedExceptionsListProps {
  exceptions: string[];
  onDelete: (exception: string) => void;
  alreadyAdded?: string[];
}

const ListWrapper = styled.div`
  display: flex;
  gap: 0.5rem;
  flex-wrap: wrap;
`;

const SelectedExceptionsList: React.FC<SelectedExceptionsListProps> = ({ exceptions, onDelete, alreadyAdded = [] }) => {
  return (
    <ListWrapper>
      {exceptions.map((exception, idx) => (
        <CreditExceptionTag
          key={idx}
          exception={exception}
          dismissible
          onDismiss={() => onDelete(exception)}
          flagged={alreadyAdded.includes(exception)}
        />
      ))}
    </ListWrapper>
  );
};

export default SelectedExceptionsList;
